import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n/index";
import "@/assets/css/global.css";
import "@/assets/css/iconfont.css";
import ElementUI from "element-ui";
import Meta from "vue-meta";
Vue.use(ElementUI);
Vue.config.productionTip = false;
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload, {
  lazyComponent: true,
  attempt: 1
});
Vue.use(Meta);
if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  store,
  i18n,
  metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description
        }
      ]
    };
  }
}).$mount("#app");
